export const environment = {
  production: true,
  host: 'http://sit-sso.chint.com',
  eqding_host: 'http://sit-dz.chint.com'
};
